import React from 'react'
import DocTitle from "./shared/DocTitle"
import HomeContainer from "./home/components/HomeContainer"
import DashboardContainer from "./dashboard/components/DashboardContainer"
import {Redirect, Route, Switch} from "react-router"
import ResetPassword from "./user-information/reset-password/components/ResetPassword"

function App() {
    return (
        <div className="App">
            <DocTitle title="Hệ thống chăm sóc khách hàng"/>
            <Switch>
                <Route path="/" exact component={HomeContainer}/>
                <Route path="/crm" component={DashboardContainer}/>
                <Route patch="/reset-password" exact component={ResetPassword}/>
                <Redirect to="/"/>
            </Switch>
        </div>
    )
}

export default App
